import {PACKAGES_TYPE} from '../actions/types';

const INITIAL_STATE = {
  length: 0,
  data: null,
  packages: null,
};

const MyPackages = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PACKAGES_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default MyPackages;
